export const config = {
  create: '時間の作成に成功しました',
  update: '時刻が正常に更新されました',
  createFail: '時間の作成に失敗しました',
  updateFail: '時刻の更新に失敗しました',
}
